import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

import { GeneralError } from '../GeneralError.view.tsx';

const NotAuthorized = () => {
  const { t } = useTranslationWithPrefix('generalError.notAuthorized');

  return <GeneralError hideButton message={t('message')} subMessage={t('subMessage')} />;
};

export default NotAuthorized;
